/*!
 * KoliBri - The accessible HTML-Standard
 */
import { u as setRuntimeMode, v as se, L as Log } from './common-D-vggmh2.js';
import { s as setCustomTagNames } from './component-names-DwvrfFak.js';
import { i as initializeI18n } from './i18n-C73LqPIs.js';

let initialized = false;
let options;
const bootstrap = async (themes, loaders, koliBriOptions) => {
    var _a, _b;
    const nodeEnv = typeof process !== 'undefined' && process.env ? "production" : undefined;
    setRuntimeMode((koliBriOptions === null || koliBriOptions === void 0 ? void 0 : koliBriOptions.environment) || nodeEnv || 'production');
    initializeI18n((_b = (_a = koliBriOptions === null || koliBriOptions === void 0 ? void 0 : koliBriOptions.translation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'de', koliBriOptions === null || koliBriOptions === void 0 ? void 0 : koliBriOptions.translations);
    if (koliBriOptions === null || koliBriOptions === void 0 ? void 0 : koliBriOptions.transformTagName) {
        setCustomTagNames(koliBriOptions === null || koliBriOptions === void 0 ? void 0 : koliBriOptions.transformTagName);
    }
    const coreRegisterReturnValue = await se(themes, loaders, koliBriOptions);
    initialized = true;
    options = koliBriOptions;
    Log.info('Development mode active - Enhanced debugging features available');
    return coreRegisterReturnValue;
};
const register = bootstrap;
const isInitialized = () => initialized;
const getOptions = () => options;

export { bootstrap as b, getOptions as g, isInitialized as i, register as r };
//# sourceMappingURL=bootstrap-Bfno1qh2.js.map

//# sourceMappingURL=bootstrap-Bfno1qh2.js.map